import React from 'react';
import PropTypes from 'prop-types';

import Hyperlink from '../Hyperlink/Hyperlink';


function LinkSwitch({ children, href, ...restProps }) {
  const newProps = { ...restProps };
  delete newProps.dispatch;
  delete newProps.target;
  delete newProps.rel;

  return (
    <Hyperlink {...newProps} href={href} to={href}>
      {children}
    </Hyperlink>
  );
}

LinkSwitch.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
};

export default LinkSwitch;
